export default __webpack_public_path__ + "static/media/teachers_graphic.0c6ee0f8.png";